import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useBundleInspectorStore } from "../../store/bundleInspectorStore";
import CanvasTooltip from "./CanvasTooltip";
import { formatBundleQuantity } from "../../utils/bundleQuantity";

// Follows the cursor, since a bundle has no single place to anchor to. Hidden while the pointer is off
// the canvas, because the command isn't told when the pointer leaves. Must live outside <Canvas>.
const BundleInspectorTooltipOverlay = () => {
    const { t, i18n } = useTranslation();
    const bundles = useBundleInspectorStore((s) => s.bundles);
    const [pos, setPos] = useState<{ x: number; y: number } | null>(null);

    useEffect(() => {
        const handler = (e: MouseEvent) =>
            setPos(e.target instanceof HTMLCanvasElement ? { x: e.pageX, y: e.pageY } : null);
        document.addEventListener('mousemove', handler);
        return () => document.removeEventListener('mousemove', handler);
    }, []);

    if (bundles === null || pos === null) return null;

    const quantityOf = (amount: number | null, unit: string | null) =>
        formatBundleQuantity(amount, unit, i18n.language, () => t('command.bundleInspector.units.pcs'));

    const content = bundles.length === 0
        ? t('command.bundleInspector.noBundle')
        : <>
            {bundles.map(b => {
                const quantity = quantityOf(b.amount, b.amountUnit);
                return <div key={b.id}>
                    {b.name}
                    {quantity && <span className="bundleInspectorQuantity"> · {quantity}</span>}
                </div>;
            })}
            {bundles.length > 1 &&
                <div className="bundleInspectorWarning">
                    ⚠ {t('command.bundleInspector.multipleBundles', { count: bundles.length })}
                </div>}
          </>;

    return <CanvasTooltip x={pos.x} y={pos.y} text={content} className="bundleInspectorTooltip" />;
};

export default BundleInspectorTooltipOverlay;
